import { BASE_URL, STORAGE_SUF } from "../constants"
import { fetchWithAuth } from "../utils/fetchWithAuth"

const suffix = localStorage.getItem(STORAGE_SUF) || ""

export type BackupFile = {
  name: string
  size: string
  createdAt: string
  url?: string
}

export const deleteBackupFile = async (
  category: string,
  fileName: string,
): Promise<void> => {
  try {
    const response = await fetchWithAuth(`${BASE_URL}/backup-files-${suffix}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ category, fileName }),
    })

    if (!response.ok) {
      throw new Error(`Failed to delete backup file`)
    }
  } catch (error) {
    console.error(`Error deleting backup file`, error)
    throw error
  }
}

export const downloadBackupFile = async (
  category: string,
  fileName: string,
): Promise<void> => {
  try {
    const response = await fetchWithAuth(
      `${BASE_URL}/backup-files-${suffix}/download?category=${category}&fileName=${encodeURIComponent(fileName)}`,
    )

    if (!response.ok) {
      throw new Error(`Failed to download backup file`)
    }

    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = fileName
    link.click()
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error(`Error downloading backup file`, error)
    throw error
  }
}

export const getBackupFiles = async (
  category: string,
): Promise<BackupFile[]> => {
  try {
    const response = await fetchWithAuth(`${BASE_URL}/backup-files-${suffix}?category=${category}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })

    if (!response.ok) {
      throw new Error(`Failed to fetch backup files`)
    }

    const data = await response.json()

    return data
  } catch (error) {
    console.error(`Error fetching backup files`, error)
    throw error
  }
}
